import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsGeneralConditionsTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CONDICOES_GERAIS, {
    ref_figma: '4',
    screen: 'Resgatar nova Sortezinha',
    ref_type: 'botão',
    product: 'capitalização',
    flow: 'prateleira',
  })
}

export const analyticsInfoLegaisTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.INFO_LEGAIS, {
    ref_figma: '5',
    screen: 'Resgatar nova Sortezinha',
    ref_type: 'botão',
    product: 'capitalização',
    flow: 'prateleira',
  })
}

export const analyticsTooltipTag = ({ value }: { value: string }) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '76',
    screen: 'resgate',
    ref_type: 'tooltip',
    action_id: 'tooltip resgate',
    value,
    currency: 'BRL',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsSubmitRepurchaseTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '79',
    screen: 'resgate nova sortezinha',
    ref_type: 'botao',
    action_id: 'resgatar',
    content_action: 'toque',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsRepurchaseLoad = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Renovar',
    product_area: 'Resgate',
    product: 'capitalização',
    step: '2',
    flow: 'prateleira',
    ...params,
  })
}
